import { FC } from 'react'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import SchoolAbout from '../../../../../components/Blocks/SchoolAbout/desktop'
import { ISchoolPageProps } from '../../../school/index/types'

const Block = styled.div`
  background-color: ${sv.color.navy};
  color: white;
  padding: 56px 0 120px 0;
`

const IndexEgePageAbout: FC<
  ISchoolPageProps['content']['about'] & {
    indicators: ISchoolPageProps['content']['indicators']
  }
> = (props) => {
  return (
    <Block>
      <SchoolAbout {...props} />
    </Block>
  )
}

export default IndexEgePageAbout
